<template>
  <div class="main" style="margin-top: 30px">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人设置</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="user-container flex">
      <div class="user-container-left">
        <div class="user-aviator flex flex_align-items flex_justify-center">
          <div class="aviator pointer" v-loading="loading" :element-loading-text="loadingText">
            <img v-if="!userInfo.photo" src="@/assets/image/aviator.png" alt="">
            <img v-else :src="baserUrl + userInfo.photo" alt="">
            <div class="aviator-replace">
              <el-upload
                  :action=" uploadUrl"
                  name="files"
                  :data="uploadData"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :on-error="handleAvatarError"
              >
                <span>更换头像</span>
              </el-upload>
            </div>
          </div>
          <div class="title">
            {{ userInfo.loginName || '' }}
          </div>
        </div>
        <div class="user-warp">
          <h2>账号管理</h2>
          <ul>
            <li :class="['flex','menu-item', 'pointer', 'flex_align-items', 'flex_space-between' ,menuIndex === index ? 'menu-item-active':''] "
                v-for="(item,index) in menuList" :key="index" @click="handleMenu(item,index)">
              <span>{{ item.name }}</span>
              <i class=" el-icon-arrow-right"></i>
            </li>
          </ul>
        </div>
      </div>

      <div class="user-container-right">
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "HomeUser",
  data() {
    return {
      menuList: [
        {
          name: '账号管理',
          url: '/homeUser/useRaccountNumber',
          index: 0
        },
        {
          name: '个人资料',
          url: '/homeUser/userInfo',
          index: 1
        },
        {
          name: '重置密码',
          url: '/homeUser/userRealName',
          index: 2
        },
        {
          name: '学习情况',
          url: '/homeUser/learningSituation',
          index: 3
        }
      ],
      menuIndex: 0,
      userInfo: {},
      fileList: [],
      baserUrl: this.$API.BASE_URL,
      uploadUrl: this.$API.MEMBER_UPDATEIMGURL,
      uploadData: {
        token: localStorage.getItem('token')
      },
      loading: true,
      loadingText: '加载中'
    }
  },
  created() {
    this.$get(this.$API.MEMBER_INFO, {}).then(res => {
      if (res.code === 200) {
        this.userInfo = res.data
        this.$emit('user', this.userInfo)
        this.loading = false
      }
    })
    // 每次刷新页面避免选择不到当前页面
    this.menuList.forEach( item => {
      if(item.url === this.$route.path) {
        this.menuIndex = item.index
      }
    })
  },
  methods: {
    handleMenu(item, index) {
      this.$router.replace({path: item.url})
      this.menuIndex = index
    },
    handleAvatarSuccess(res, file) {
      this.loading = false;
      this.userInfo.photo = res.data.photo;
      this.$emit('user', this.userInfo)
    },
    handleAvatarError(e) {
      this.$message.error(e)
    },
    beforeAvatarUpload(file) {
      this.loading = true
      this.loadingText = '上传中'
      const isLt2M = file.size / 1024 / 1024  < 1;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 `1MB!');
        this.loading = false
      }
      return isLt2M;
    }
  },
  watch: {
    $route: { // 进行监听路由变化，在每个模块上加状态
      handler: function (val) {
        this.menuList.forEach( item => {
          if(item.url === val.fullPath) {
            this.menuIndex = item.index
          }
        })
      },
      // 深度观察监听
      deep: true
    }
  },
}
</script>

<style scoped lang="scss">
.user-container {
  margin-top: $spacing-row-base;

  &-left {
    width: 260px;
    flex-shrink: 0;
    background: #f8fafc;
    height: 100%;

    .user-aviator {
      text-align: center;
      flex-direction: column;
      padding: $spacing-row-base 0;

      .aviator {
        position: relative;
        border: 4px solid #d9dde1;
        width: 122px;
        height: 122px;
        border-radius: 50%;
        overflow: hidden;

        &:hover {
          .aviator-replace {
            bottom: 0;
          }
        }

        img {
          border-radius: 50%;
        }

        &-replace {
          transition: all .3s;
          position: absolute;
          bottom: -100%;
          width: 100%;
          color: #FFFFFF;
          line-height: 40px;
          font-size: $font-size-base;
          background: rgba(0, 0, 0, 0.6);
        }
      }

      .title {
        margin: $spacing-row-sm;
      }
    }

    .user-warp {
      padding-bottom: $spacing-row-base;
      h2 {
        font-size: $font-size-lg;
        padding: $spacing-row-sm 0;
        margin: 0 $spacing-row-base $spacing-row-sm;
        border-bottom: 1px solid #d9dde1;
      }

      ul {
        margin: $spacing-row-sm 0;
      }

      .menu-item {
        height: 50px;
        line-height: 50px;
        padding-left: 40px;
        padding-right: 30px;
        font-size: $font-size-base;
      }

      .menu-item-active {
        background: #409eff;
        color: $font-text-color-inverse;
      }
    }
  }

  &-right {
    flex: 1;
    margin-left: 30px;
  }
}
</style>
